<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">个人资料</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="content">
                <div class="top">
                    <div class="key">头像</div>
                    <img class="user-img" :src="user.userAvatar ? user.userAvatar : defaultImg">
                </div>
                <div class="center">
                    <div class="center-item">
                        <div class="center-key">昵称</div>
                        <div class="value">{{user.userName}}</div>
                    </div>
                    <div class="center-item">
                        <div class="center-key">性别</div>
                        <div class="value">{{user.userSex ? '女' : '男'}}</div>
                    </div>
                    <div class="center-item">
                        <div class="center-key">年龄</div>
                        <div class="value">{{getAge(user.userBirthday)}}</div>
                    </div>
                    <div class="center-item">
                        <div class="center-key">体重</div>
                        <div class="value">{{user.userWeight}}<span class="unit">公斤</span></div>
                    </div>
                    <div class="center-item">
                        <div class="center-key">身高</div>
                        <div class="value">{{user.userHeight}}<span class="unit">厘米</span></div>
                    </div>
                    <div class="center-item center-item-last">
                        <div class="center-key">地区</div>
                        <div class="value">{{user.userArea}}</div>
                    </div>
                </div>
                <div class="center">
                    <div class="center-item">
                        <div class="center-key">步幅</div>
                        <div class="value">{{user.userStep}}<span class="unit">厘米</span></div>
                    </div>
                    <div class="center-item">
                        <div class="center-key">日常目标</div>
                        <div class="value">{{user.userTargetStep}}<span class="unit">，</span>{{user.userTargetCalorie}}<span
                                class="unit">千卡</span></div>
                    </div>
                    <div class="center-item" @click="toHrRange">
                        <div class="center-key">心率区间</div>
                        <div class="value"><img class="to-icon" src="@/assets/theme/light/desc/01prodInstructions/04to.svg"></div>
                    </div>
                </div>
            </div>
            <div class="del-btn" @click="deleteFriend" v-if="isFirend">移除好友</div>
        </div>
    </div>
</template>
<script>
    import {getAge} from "../../utils/dateUtils";
    import {Dialog, Toast} from 'vant'
    export default {
        name: 'personal',
        data() {
            return {
                theme: 'light',
                defaultImg: require('@/assets/share/home/noImg.png'),
                sharerId: localStorage.getItem('sharerId'),
                user: {},
                isFirend: 0
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.getInfo();
            this.isFirend = this.$route.params.isFirend;
        },
        methods: {
            back() {
                this.$router.back();
            },
            getInfo() {
                this.$api.share.friendInformation({
                    sharerId: this.sharerId
                }).then(res => {
                    this.user = res.info
                })
            },
            getAge(n) {
                if (n) {
                    return getAge(n)
                }
            },
            deleteFriend() {
                Dialog.confirm({
                    message: '移除后将无法查看对方数据，同时也会从对方列表中将你移除，' +
                        '确认移除该好友？',
                    getContainer: "#app",
                    confirmButtonColor: '#00BD9B',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    cancelButtonColor: 'rgba(0,0,0,0.5)',
                }).then(() => {
                    this.$api.share.deleteMembers({
                        sharerId: this.sharerId
                    }).then(res => {
                        Toast.success('删除成功！');
                        this.$router.back();
                    })
                }).catch(() => {
                    // on cancel
                });
            },
            toHrRange() {
                this.$router.push({
                    name: 'hrRangeLight',
                    query: {
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .top {
        width: 345px;
        height: 60px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 6px;
        margin: 16px auto 10px;
        position: relative;
        color: var(--text-color-1);
    }

    .key {
        position: absolute;
        font-size: 14px;
        color: var(--text-color-1);
        top: 20px;
        left: 20px;
    }

    .user-img {
        width: 40px;
        position: absolute;
        top: 10px;
        right: 17px;
        border-radius: 50%;
    }

    .center {
        width: 345px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 6px;
        margin: 0 auto 15px;
    }

    .center-item {
        height: 51px;
        position: relative;
    }

    .center-key {
        position: absolute;
        font-size: 15px;
        color: var(--text-color-1);
        top: 16px;
        left: 20px;
    }

    .value {
        position: absolute;
        font-size: 15px;
        color: var(--text-color-2);
        top: 16px;
        right: 16px;
    }

    .center-item-last {
        border: none;
    }

    .to-icon {
        width: 16px;
    }

    .del-btn {
        width: 345px;
        height: 56px;
        border-radius: 13px 13px 13px 13px;
        border: 2px solid #404040;
        font-size: 17px;
        line-height: 56px;
        text-align: center;
        color: var(--text-color-1);
        margin: 0 auto;
    }

    /deep/ .van-hairline--top::after {
        border: 1px solid var(--text-color-1);
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/15personal.vue